import React, { ReactNode } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';

export type SMSShareProps = WithTrack & {
  children: ReactNode;
  url: string;
  className?: string;
  message: string;
  trackingData?: Record<string, any>;
};

export class SMSShare extends React.PureComponent<SMSShareProps> {
  trackClick = () => {
    const { track, trackingData } = this.props;
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'sms',
      ...trackingData,
    });
  };

  render() {
    const { children, className, message, url } = this.props;

    return (
      <a
        href={`sms://?&body=${message} ${encodeURIComponent(url)}%20`}
        className={`jg-btn jg-btn--sms ${className}`}
        onClick={this.trackClick}
      >
        {children}
      </a>
    );
  }
}

export default withTrack(SMSShare);
